import React from 'react';
import Card from '../../components/ui/Card.jsx';

export default function StudentForms() {
  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Forms</h1>
          <p className="subtle">Official Electrical and Computer Engineering forms.</p>
        </div>
      </div>

      <Card title="Updated Forms">
        <p>
          To access updated forms, please go to{' '}
          <a href="https://www.calstatela.edu/ecst/ece/forms" target="_blank" rel="noreferrer">
            https://www.calstatela.edu/ecst/ece/forms
          </a>
          .
        </p>
        <a className="btn btn-primary" href="https://www.calstatela.edu/ecst/ece/forms" target="_blank" rel="noreferrer">
          Open ECE Forms
        </a>
      </Card>
    </div>
  );
}
